export default "__VITE_ASSET__0f23239b__"